import React from "react";
import "./index.scss";
import { IMdaeFeedbackWidget } from "./index";
import MdaeButton from "../button";
const MdaeFeedbackWidget: React.FC<IMdaeFeedbackWidget> = (props) => {
  return (
    <>
      {props.isMdaeFeedbackWidgetVisible && (
        <div className={"sys-mdae-feedback-widget-content " + props.feedbackSectionClassName}>
          <MdaeButton
            id="thumbsUp"
            role={"dxButton"}
            className={props.thumbsUpClassName}
            onClick={props.onThumbsUpClick}
            disabled={props.thumbsUpDisabled}
          ></MdaeButton>
          <MdaeButton
            id="thumbsDown"
            role={"dxButton"}
            className={props.thumbsDownClassName}
            onClick={props.onThumbsDownClick}
            disabled={props.thumbsDownDisabled}
          ></MdaeButton>
          {props.feedbackText && (
            <h6 style={{ color: "teal", display: "inline-block" }}>
              {props.feedbackText}
            </h6>
          )}
          {props.feedbackLinkText && (
            <a
              style={{ color: "teal", cursor: "pointer" }}
              onClick={props.onFeedbacklinkClick}
            >
              {props.feedbackLinkText}
            </a>
          )}
        </div>
      )}
    </>
  );
};
export default MdaeFeedbackWidget;
